import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitorStatsPageRouteMetaDataModel extends CompetitorPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITOR.stats)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITOR.stats)
    }

    return description
  }

  get staticTitle() {
    return this.titleFormatTerm(this.websiteTerms.WEB_COMPETITOR_STATS_TITLE_TEMPLATE);
  }

  get staticDescription() {
    return this.descriptionFormatTerm(this.websiteTerms.WEB_COMPETITOR_STATS_DESCRIPTION)
  }
}